export default __webpack_public_path__ + "static/media/feature-3.faa862e7.svg";